import { render } from "./About.vue?vue&type=template&id=380248c0"
const script = {}
script.render = render

export default script